<input type="checkbox" [checked]="checked" [disabled]="disabled" />
